export const ORG_TYPE_ENTERPRISE = 'enterprise';
export const ORG_TYPE_TIER1 = 'tier1';
export const ORG_TYPE_TIER2 = 'tier2';
export const ORG_TYPE_TIER3 = 'tier3';
export const ORG_TYPE_TIER4 = 'tier4';
export const ORG_TYPE_STORE = 'org_store_id';
